import { render, staticRenderFns } from "./Step-5.vue?vue&type=template&id=0adda8e9&"
import script from "./Step-5.vue?vue&type=script&lang=js&"
export * from "./Step-5.vue?vue&type=script&lang=js&"
import style0 from "./Step-5.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports